// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"2c294c5b","293":"2633c164","598":"e2639fd1","663":"ad1c1a26","728":"f9b868de"}[chunkId] + ".chunk.js";
};